/**
 * @typedef {("Trial" | "Permanent")} UserSubscription
 */

/**
 * @typedef UserSubscriptionEnum
 * @property {UserSubscription} trial
 * @property {UserSubscription} permanent
 */

/**
 * @type {UserSubscriptionEnum}
 */
export const USER_SUBSCRIPTION = {
  trial: "Trial",
  permanent: "Permanent"
};

/**
 * Get user type from user claims
 *
 * @param {import("src/store/modules/auth").User} user
 * @returns {import("src/store/modules/auth").UserType}
 */
export function getUserType(user) {
  const { claims } = user;
  for (const userClaim of claims) {
    if (userClaim.value.toLowerCase() === "admin") {
      return "Admin";
    }
  }
  return "Client";
}
/**
 * Get user subscription status as string
 *
 * @param {import("src/store/modules/auth").User} user
 * @returns {UserSubscription}
 */
export function getUserSubscriptionString(user) {
  return user.trial ? USER_SUBSCRIPTION.trial : USER_SUBSCRIPTION.permanent;
}
